module.exports = __webpack_public_path__ + "static/media/(H)-Artesanato-11.6104d6ba.jpg";